import { supabase } from "../../config/supabase";

// Update a course
const getSubmissionById = async (submitId) => {
    try {
        const { data, error } = await supabase.from('challenge_submissions').select('*').eq('submit_id', submitId).single(); 
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting challenge submissions:',err);
        return { error: err, data:null };
    }
};

const getAllSubmissions = async (page,limit = 10) => {
    try {
        const { data, error } = await supabase.from('challenge_submissions').select('*', { count: 'exact' }).range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting challenge submissions:',err);
        return { error: err, data:null };
    }
};

export { getSubmissionById, getAllSubmissions };